import React, {Component} from 'react'
import {connect} from 'react-redux'
import CopyURLSegment from "../../SharedComponents/CopyURLSegment";
import {getFileURL} from "../../Constants/getFileURL";
import SampleQuestionsAccordion from "../../SharedComponents/SampleQuestionsAccordian";
import McpIntegrations from "./McpIntegrations";

class MCPIndex extends Component {
    constructor(props) {
        super(props);
    }

    getMcpURL = () => {
        const originalMcpURL = this.props.getURL.replace("/data/", "/mcp/");
        console.log('originalMcpURL:', originalMcpURL);
        
        const urlParts = originalMcpURL.split('/');
        console.log('urlParts:', urlParts);
        console.log('urlParts.length:', urlParts.length);
        console.log('last part:', urlParts[urlParts.length - 1]);
        
        const mcpIndex = urlParts.findIndex(part => part === 'mcp');
        console.log('mcpIndex:', mcpIndex);
        
        if (mcpIndex !== -1 && urlParts[mcpIndex + 1]) {
            const fileHashWithQuery = urlParts[mcpIndex + 1];
            console.log('fileHashWithQuery:', fileHashWithQuery);
            const fileHash = fileHashWithQuery.split('?')[0];
            console.log('fileHash after split:', fileHash);
            
            // Extract accessKey and secretKey from query parameters
            console.log(this.props.fileInformation[this.props.pkID])
            const queryString = originalMcpURL.split('?')[1] || '';
            const urlParams = new URLSearchParams(queryString);
            const accessKey = this.props.fileInformation[this.props.pkID].accessKey;
            const secretKey = this.props.fileInformation[this.props.pkID].secretKey;
            
            console.log('fileHash:', fileHash);
            console.log('accessKey:', accessKey);
            console.log('secretKey:', secretKey);
            console.log('queryString:', queryString);
            
            if (!fileHash || !accessKey || !secretKey) {
                return "MCP URL not available";
            }
            
            return `https://mcp.apispreadsheets.com/file/${fileHash}/${accessKey}/${secretKey}`;
        }
        
        return "MCP URL not available";
    };

    render() {
        const mcpURL = this.getMcpURL();
        
        return (
            <div>
                <CopyURLSegment
                    url={mcpURL}
                    header={<span>MCP URL</span>}
                />
                <McpIntegrations />
                <SampleQuestionsAccordion open />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    fileInformation: state.mainState.fileInformation,
    sheetRead: state.mainState.sheetRead
})

export default connect(mapStateToProps)(MCPIndex)